import React, { PropsWithChildren, ReactNode } from "react";

import css from "./index.module.scss";

type Props = {
  className?: string;
  note?: ReactNode;
  text?: string;
  useDiv?: boolean;
};

export const Label = ({
  children,
  className,
  note,
  text,
  useDiv = false,
}: PropsWithChildren<Props>) => {
  const Tag = useDiv ? "div" : "label";

  return (
    <Tag className={className}>
      {text && <span className={css.label}>{text}</span>}
      {note && <span className={css.note}>{note}</span>}
      {children}
    </Tag>
  );
};
